import { useNavigate } from 'react-router-dom';

export function usePricesListNav() {
	const navigate = useNavigate();

	return {
		go_to_preview_page: (version_date: number) => navigate(`/precos/${version_date}/visualizar`),
	};
}
